import {defineStore} from 'pinia'
import {readonly, ref} from 'vue'
import axios from 'axios'
import {castAttributesForSnakeCase} from 'src/biz_spa/modules/string_converter'
import {useFlash} from 'src/biz_spa/composables'
import { i18n } from 'src/biz_spa/plugins/i18n'
type updateReviewReplyApprovalFlowParams = {
  replyApprovalFlow: boolean
}

export const useCompaniesReviewReplyApprovalFlowStore = defineStore('companiesReviewsReplyApprovalFlow', () => {
  const isLoading = ref<boolean>(false)
  const { updateFlash } = useFlash()

  const updateReviewReplyApprovalFlow = async ({ companyUuid, params }: { companyUuid: string, params: updateReviewReplyApprovalFlowParams }) => {
    if (isLoading.value) return

    isLoading.value = true
    const reqParams = {
      approvalFlow: {
        ...params
      }
    }
    return axios
      .put(`/api/companies/${companyUuid}/reviews/replies/approval_flow`, castAttributesForSnakeCase(reqParams))
      .then(() => {
        updateFlash({ type: 'notice', message: i18n.t('messages.updated', { value: i18n.t('models.company.replyApprovalFlow') }) })
        return true
      })
      .catch(err => {
        updateFlash({ type: 'alert', message: err.response.data.errors[0].detail })
        return false
      })
      .finally(() => {
        isLoading.value = false
      })
  }

  return {
    isLoading: readonly(isLoading),
    updateReviewReplyApprovalFlow,
  }
})
